module.exports = __webpack_public_path__ + "img/2-8-3.27a43806.png";